import { domMax, LazyMotion, MotionConfig } from "framer-motion";
import type { ReactNode } from "react";

/**
 * Single motion runtime for the whole admin v2 app.
 *
 * - LazyMotion(strict) forces the lightweight `m` components everywhere (no full
 *   `motion` component is allowed), keeping bundle impact predictable.
 * - domMax loads animations, exit, gestures (incl. whileInView) and layout.
 * - MotionConfig reducedMotion="user" makes every animation honor the OS-level
 *   "prefers-reduced-motion" setting automatically.
 */
export function MotionProvider({ children }: { children: ReactNode }) {
  return (
    <LazyMotion features={domMax} strict>
      <MotionConfig reducedMotion="user">{children}</MotionConfig>
    </LazyMotion>
  );
}
